import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var BusinessAccountingIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    "clip-rule": "evenodd",
    d: "M16.7787 9.5C16.7787 7.42894 18.4576 5.75 20.5287 5.75H27.4715C29.5426 5.75 31.2215 7.42893 31.2215 9.5V11.3442H40.5C42.5711 11.3442 44.25 13.0232 44.25 15.0942V35.8646C44.25 37.9356 42.5711 39.6146 40.5 39.6146H7.5C5.42893 39.6146 3.75 37.9356 3.75 35.8646V15.0942C3.75 13.0232 5.42893 11.3442 7.5 11.3442H16.7787V9.5ZM16.7787 13.8443V13.8442H7.5C6.80964 13.8442 6.25 14.4039 6.25 15.0942V35.8207L13.9958 27.1943C14.9482 26.1338 16.4194 25.7048 17.7925 26.0873L25.7331 28.2997C26.1944 28.4282 26.6885 28.2819 27.0055 27.923L30.8259 23.5974L28.5799 21.7787L38.8903 15.7995L35.1855 27.1278L32.7705 25.1722L28.8793 29.578C27.9284 30.6546 26.4459 31.0935 25.0621 30.708L17.1215 28.4956C16.6638 28.3681 16.1734 28.5111 15.856 28.8646L8.44817 37.1146H40.5C41.1904 37.1146 41.75 36.5549 41.75 35.8646V15.0942C41.75 14.4039 41.1904 13.8442 40.5 13.8442H31.2215V13.8443H16.7787ZM28.7215 9.5V11.3442H19.2787V9.5C19.2787 8.80964 19.8383 8.25 20.5287 8.25H27.4715C28.1619 8.25 28.7215 8.80964 28.7215 9.5Z"
  }));
});
BusinessAccountingIcon.displayName = 'BusinessAccountingIcon';
BusinessAccountingIcon.defaultProps = {
  'aria-label': 'Accounting'
};
export default BusinessAccountingIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/BusinessAccountingIcon/index.js
// module id = 1986
// module chunks = 12